// extracted by mini-css-extract-plugin
export default {"inner":"O_inner__GYg+O","outer":"O_outer__cIhl2","inner1":"O_inner1__h4nX0","inner2":"O_inner2__xhb9o","wrapper":"O_wrapper__5wl-X"};